export default {
  首页: "Maison",
  资产: "Les atouts",
  币币: "Devise",
  快捷买币: "Commerce P2P",
  "支持多种方式购买，购买更简单":
    "Soutenir plusieurs façons d'acheter, acheter plus simple",
  语言设置: "Paramètres de langue",
  确认恢复: "Confirmer la récupération",
  "输入邮箱，方便我们联系您":
    "Entrez votre email afin que nous puissions vous contacter",
  划转: "Transférer",
  行情: "Devis",
  "24H成交": "transaction 24h/24",
  累计收益: "Revenu cumulé",
  充值时间: "Temps de recharge",
  到期时间: "Date d'expiration",
  数量: "Quantité",
  操作: "Fonctionner",
  资产信息: "Informations sur l'actif",
  复制地址: "copier l'adresse",
  链名称: "Nom de la chaîne",
  充值地址: "adresse de recharge",
  收款地址: "Adresse de facturation",
  账单: "Facture",
  提现金额: "Montant de retrait",
  接收地址: "Adresse de réception",
  交易密码: "Mot de passe transactionnel",
  提现全部: "Tout retirer",
  保存图片: "Enregistrer l'image",
  输入您的交易密码: "Mot de passe transactionnel",
  确定: "Bien sûr",
  地址: "Adresse",
  注册时间: "Signer l'heure",
  取消: "Annuler",
  是否划转: "Que ce soit pour transférer",
  登录: "Connexion",
  我的地址: "Mon adresse",
  登录密码和交易密码:
    "Mot de passe de connexion et mot de passe de transaction",
  注册: "S'inscrire",
  密码: "Mot de passe",
  设置密码: "Définir le mot de passe",
  重复密码: "Répéter le mot de passe",
  新密码: "Nouveau mot de passe",
  确认新密码: "Confirmez le nouveau mot de passe",
  充值: "Recharger",
  充值货币: "Recharger",
  合约账户充值: "Rechargement du compte à terme",
  账户充值: "Rechargement de compte",
  其他: "Autre",
  我的邀请码: "Code d'invitation",
  提现: "Se désister",
  客服: "Client",
  持有详情: "Détails de détention",
  请输入内容: "Veuillez entrer du contenu",
  邀请好友来领取奖励: "Invitez des amis pour recevoir des récompenses",
  复制链接: "Copie",
  重复设置新的密码: "Répéter la définition du nouveau mot de passe",
  保存: "sauvegarder",
  我的: "Mien",
  "邮箱/手机号": "E-mail/numéro de portable",
  备注: "Remarque",
  地址管理: "Mon adresse",
  我的团队: "Équipes",
  联系我们: "Contactez-nous",
  竭诚为您服务: "Cordialement à votre service",
  提取收益: "Revenu de retrait",
  带给我的收益: "Mon avantage",
  添加: "Ajouter",
  名称: "Nom",
  添加地址: "Ajoutez l'adresse",
  修改地址: "Changement d'adresse",
  可提现: "Peut être retiré",
  安全中心: "Centre de sécurité",
  收益划转: "Transfert de revenus",
  通知中心: "Notification",
  "累计收益:": "Gains cumulés :",
  注册用户: "Utilisateur enregistré",
  奖励规则: "Règles de récompense",
  帮助反馈: "Commentaires d'aide",
  邀请好友: "Inviter des amis",
  恢复身份: "Restaurer l'identité",
  选择语言: "Choisissez la langue",
  设置新的密码: "Definir un nouveau mot de passe",
  暂无活动: "Aucune activité",
  "月增长量(+)": "Croissance mensuelle (+)",
  可提取: "Extractible",
  反馈类型: "Type de commentaire",
  赠送: "Révéler",
  已经复制: "Copié",
  保存成功: "Enregistré avec succès",
  划转成功: "Transfert réussi",
  过期: "Expiré",
  提交成功: "Soumis avec succès",
  "服务器繁忙，稍后在试": "Le serveur est occupé, essai plus tard",
  全部: "Tout",
  一级: "Niveau 1",
  二级: "Niveau 2",
  三级: "Niveau 3",
  级: "Classer",
  删除成功: "Supprimé avec succès",
  选择地址: "Choisissez l'adresse",
  不再提醒: "Aucun rappel",
  "最小充值金额：": "Recharge minimale :",
  选择币种: "Sélectionnez la devise",
  输入投资金额: "Coût d'investissement",
  输入账户密码: "Mot de passe",
  投资: "Investir",
  订单编号: "Numéro de commande",
  投资周期: "Cycle",
  投资资金: "Fonds",
  投资时间: "Temps",
  状态: "État",
  投资中: "Investissement",
  已到期: "Expiré",
  暂无数据: "Pas de données",
  转入: "Transférer dans",
  邮箱: "Courrier",
  请输入邮箱: "E-mail",
  请输入格式正确的邮箱: "Adresse e-mail",
  请输入验证码: "Le code de vérification",
  获取验证码: "Obtenir le code",
  请输入邀请码: "Code d'invitation",
  今天: "Aujourd'hui",
  昨天: "Hier",
  最近七天: "sept derniers jours",
  邀请: "Inviter",
  购买数量: "Quantité d'achat",
  产品详情: "détails du produit",
  币种: "Devise",
  利息币种: "Devise d'intérêt",
  理财类型: "Type financier",
  产品费率: "Tarif du produit",
  进行中: "Traitement",
  每天: "Tous les jours",
  请输入搜索关键词: "Veuillez rechercher un mot-clé",
  通知: "Remarquer",
  查看更多: "Suite",
  理财宝: "HODL & Gagnez",
  周期: "Cycle",
  年利率: "AVR",
  更多产品: "Plus de produits",
  灵活存取: "Dépôts flexibles",
  稳定收益: "Des rendements stables",
  合约指南: "Centre d'aide",
  资金划转出: "Transfert de fonds",
  矿池收益: "Revenus du pool de minage",
  提现手续费: "Frais de retrait",
  冻结资金: "Geler des fonds",
  解冻资金: "Dégeler des fonds",
  闪兑支出: "Dépenses éclair",
  闪兑收入: "Revenus d'échange flash",
  闪兑手续费: "Frais d'échange flash",
  合约支出: "Dépenses à terme",
  合约收入: "Revenus des contrats à terme",
  输入的金额不可大于可用金额:
    "Le montant saisi ne peut pas être supérieur au montant disponible",
  全部兑换成功: "Avec succès",
  返回: "Revenir",
  查看历史: "Voir l'historique",
  闪兑历史: "Historique des flashs",
  支付: "Payer",
  获取: "Obtenir",
  时间: "Temps",
  手续费: "Frais",
  折扣: "Remise",
  价格: "Prix",
  逐仓: "Isolé",
  全仓: "Traverser",
  市价委托: "Ordre au marché",
  限价委托: "Ordre à cours limité",
  请输入本金: "Montant",
  请输入价格: "Prix",
  "可做空/做多": "Court long",
  设置止盈止损: "TP/SL",
  止盈价: "Est. TP",
  止损价: "Est. SL",
  成本: "Coût",
  做多: "Long",
  做空: "Court",
  仓位信息: "Informations sur le poste",
  一键平仓: "Ferme tout",
  永续: "",
  浮动盈亏: "P&L non réalisé",
  平仓: "proche",
  反向开仓: "RVS ouvert",
  一键撤销: "Annuler en un clic",
  倍杠杆: "x effet de levier",
  执行价格: "Prix ​​d'exercice",
  委托数量: "Nombre de commandes",
  保证金: "Marge",
  成交价: "Prix ​​ouvert",
  创建时间: "créer un rendez-vous",
  撤销: "Révoquer",
  合约市场: "Marché à terme",
  交易方向: "Sens commercial",
  委托价格: "Prix ​​de la commande",
  委托金额: "Montant des commissions",
  资金费率: "Taux de financement",
  "多方和空方交易者支付的定期费用，每8小时结算一次。":
    "Une commission récurrente payée par les traders longs et courts, réglée toutes les 8 heures.",
  "资金费率为正，多方向空方支付资金费用。":
    "Le taux de financement est positif et le côté long paie les frais de financement au côté court.",
  "资金费率为负，空方向多方支付资金费用。":
    "Le taux de financement est négatif et le côté court paie les frais de financement aux multiples parties.",
  "确定反向开仓吗？反向开仓将以当期相反 的仓位进行买入":
    "Êtes-vous sûr de vouloir ouvrir une position à l'envers ? La position d'ouverture inversée sera achetée avec la position opposée actuelle",
  "仓位止盈/止损": "Position Take Profit/Stop Loss",
  合约名称: "Contrats à terme",
  开仓价格: "Prix ​​ouvert",
  指数价格: "Prix ​​de l'indice",
  止盈设置: "Paramètre de prise de profit",
  请输入止盈价: "Veuillez entrer le prix de profit",
  "当指数价格触达*时，将会触发委托平仓":
    "Lorsque le prix de l'indice touche {0}, cela déclenchera l'ordre de clôture de la position",
  预计盈亏: "Quantité de liquidation",
  当前仓位: "Position actuelle",
  平仓金额: "Montant liquidatif",
  仓位模式: "Mode position",
  全仓模式: "Mode entrepôt complet",
  "合约账户中的所有可用资金视作为可用保证金， 当仓位亏损超过了账户余额才会爆仓强平，并将损失所有 保证金和仓位，请注意":
    "Tous les fonds disponibles sur le compte à terme sont considérés comme une marge disponible. Lorsque la perte de position dépasse le solde du compte, la position sera liquidée et toutes les marges et positions seront perdues. Veuillez noter que",
  逐仓模式: "Mode marge isolée",
  "会使合约账户中的一定数量保证金被分配到仓位上。如果保证金亏损低于维持保证金的水平，仓位被强平。在逐仓模式下，您可以为这个仓位增加和减少保证金。":
    "Cela entraînera l'attribution d'un certain montant de marge dans le compte à terme à la position. Si la perte de marge tombe en dessous du niveau de marge de maintenance, cette position est liquidée. En mode position isolée, vous pouvez augmenter et diminuer la marge pour cette position.",
  "是否撤销？": "Est-il révoqué ?",
  "是否一键撤销？": "Est-ce une annulation en un clic ?",
  "是否一键平仓？": "Voulez-vous fermer une position en un clic ?",
  持仓保证金: "Marge de position",
  风险率: "Risque",
  未实现盈亏: "P&L non réalisé",
  可用保证金: "Marge libre",
  净值: "Nouvelle valeur",
  账户余额: "Solde",
  合约计算器: "Calculatrice",
  交易记录: "Relevé d'opération",
  "*倍杠杆": "{num} x",
  "平仓盈亏：": "P&L de clôture :",
  时间筛选: "Filtre horaire",
  仓位类型: "type de position",
  订单状态: "Statut de la commande",
  订单类型: "Type de commande",
  平仓价格: "Le dernier prix",
  持仓数量: "Quantité",
  "手续费(%)": "Frais de gestion (%)",
  平仓时间: "Heure de fermeture",
  平仓类型: "Type de fermeture",
  手动平仓: "Manuel",
  强制平仓: "Liquidation forcée",
  近1天: "Un jour",
  近7天: "7 jours",
  近30天: "30 jours",
  近180天: "180 jours",
  持仓: "Position",
  已取消: "Annulé",
  分时: "Temps",
  "24H额(USDT)": "Montant 24H (USDT)",
  "24H低": "24H bas",
  "24H量(BTC)": "Volume 24H (BTC)",
  "24H高": "24H de haut",
  "10秒": "10 seconde",
  "30秒": "30 seconde",
  "1分": "1 points",
  "3分": "3 points",
  "5分": "5 points",
  "30分": "30 points",
  "1小时": "1 heure",
  "4小时": "4 heures",
  "8小时": "8 heures",
  "1天": "Un jour",
  "1周": "1 semaine",
  "1月": "Janvier",
  单向持仓: "Position à sens unique",
  杠杆: "levier",
  仓位: "Position",
  计算结果: "Résultats des calculs",
  盈亏: "Profit et perte",
  收益率: "Taux de retour",
  计算结果仅供参考: "Les résultats des calculs sont à titre indicatif",
  成交后仓位大小: "Taille de la position après transaction",
  "计算结果仅供参考,实际结果可能因费率差异":
    "Les résultats des calculs sont à titre indicatif uniquement, les résultats réels peuvent varier en raison des différences de taux",
  目标价格: "Cible",
  开始计算: "Commencez à calculer",
  强平价格: "Liquidation",
  "充值前，请认真核对充值的链名称，充值错误无法找回资产*最小充值金额为*；少于此金额平台将无法确认到账，请不要向此地址充值*之外的资产，否则将无法找回资产，请不要直接提现众筹或者ICO地址，平台不会代理币的发放。":
    "Avant de recharger, veuillez vérifier attentivement le nom de la chaîne de recharge. Si la recharge est erronée, les actifs ne peuvent pas être récupérés. {0}Le montant minimum de recharge est de {1} ; si le montant est inférieur à ce montant, la plateforme ne pourra pas confirmer la réception. Veuillez ne pas recharger d'autres actifs que {2} à cette adresse, sinon il ne sera pas possible de récupérer les actifs, veuillez ne pas tirer l'adresse de financement participatif ou ICO directement, la plateforme n'agira pas comme un proxy pour l'émission de jetons.",
  "最小输入*": "Au moins {0}",
  "最小提币数量为*，提币手续费将从你的提款金额中扣除。提币前请确认核对收款地址，不要将*提现至*以外的地址，否则无法找回资产。请不要直接提现众筹或者ICO地址，平台不会处理代币的发放。":
    "Le montant minimum de retrait est de {0}, les frais de retrait seront déduits du montant de votre retrait. Avant de retirer des pièces, veuillez confirmer et vérifier l'adresse de réception, et ne pas retirer {1}à une adresse autre que {2}, sinon les actifs ne seront pas récupérés, veuillez ne pas retirer l'adresse de financement participatif ou ICO directement, la plateforme ne traitera pas l'émission de jetons.",
  退出登录: "Déconnexion",
  加仓: "Ajouter",
  新增仓位: "Ajouter",
  输入加仓金额: "Entrez le montant",
  "当前可用:": "Actuellement disponible:",
  资产账单: "Facture d'actif",
  保存二维码: "Enregistrer le code QR",
  温馨提示: "Bons conseils",
  "请注意：您当前使用的网络": "Remarque : Votre réseau actuel",
  输入提现地址: "Entrez l'adresse de retrait",
  "可用金额：": "Montant disponible :",
  输入资产密码: "Mot de passe de l'actif",
  可用手续费: "Frais de traitement disponibles",
  "折扣%": "Remise%",
  实扣手续费: "Frais de déduction réels",
  实际到账: "Crédit réel",
  未设置资产密码: "Mot de passe de l'actif non défini",
  "为了您的资产安全，请设置资产密码后再来提现。":
    "Pour la sécurité de vos actifs, veuillez définir le mot de passe de l'actif avant de retirer.",
  热榜: "Chaud",
  涨幅榜: "Monter",
  跌幅榜: "Perdant",
  成交额榜: "Commerce",
  关于我们: "À propos de nous",
  登录密码: "Mot de passe",
  设置: "Mettre en place",
  资产密码: "Mot de passe de l'actif",
  修改登录密码: "Modifier le mot de passe de connexion",
  原密码: "Ancien mot de passe",
  请输入新密码: "Nouveau mot de passe",
  请输入原密码: "Mot de passe d'origine",
  确认密码: "Confirmez le mot de passe",
  确定修改: "OK pour modifier",
  修改资产密码: "Modifier le mot de passe de l'actif",
  验证码: "Le code de vérification",
  资产密码使用提示: "Conseils pour l'utilisation du mot de passe d'actif",
  "资产密码用于转移、提取资产和交易。":
    "Le mot de passe d'actif est utilisé pour transférer, retirer des actifs et échanger.",
  "创建与登录密码不同的资产密码。":
    "Créez un mot de passe d'actif différent du mot de passe de connexion.",
  "定期更改您的资产密码。": "Changez régulièrement votre mot de passe d'actif.",
  提币历史: "Historique des retraits",
  "金额/余额": "Montant/Solde",
  "手续费/折扣": "Frais de traitement/remise",
  自选: "Optionnel",
  现货: "Endroit",
  市价: "Prix ​​du marché",
  止损设置: "Paramètre d'arrêt de perte",
  合约K线图: "Graphique K-line des contrats à terme",
  "24H量": "Volume 24h",
  "24H额": "Montant 24H",
  合作指南: "Guide de coopération",
  盈亏计算: "PL",
  当前可用: "Actuellement disponible",
  请输入加仓金额: "Veuillez entrer le montant de l'augmentation",
  请重新输入加仓金额: "Veuillez ressaisir le montant de l'augmentation",
  平仓数量: "Nombre de fermetures",
  欢迎登录: "Connectez-vous s'il vous plaît",
  "忘记密码?": "mot de passe oublié?",
  "还没有账号？": "Vous n'avez pas encore de compte?",
  立即注册: "S'inscrire maintenant",
  繁體中文: "Chinois traditionnel",
  找回密码: "Récupérer mot de passe",
  下一步: "L'étape suivante",
  注册账户: "Créer un compte",
  "请输入邀请码(选填)": "Code d'invitation (facultatif)",
  谢邀豪礼: "Invitation",
  "24小时邀请好友排名": "24 heures inviter des amis classement",
  "*人": "{0}",
  "差*人": "{0}Écart",
  "已超过10万人，每月轻松赚钱":
    "A plus de 100 000 personnes, gagnant de l'argent facilement chaque mois",
  最高: "Le plus élevé",
  邀请链接: "Lien",
  "平台和您共享好友在平台（现货、合约、杠杆、闪兑）所产生的手续费":
    "La plateforme et vous partagez les frais générés par vos amis sur la plateforme (spotutures, effet de levier, échange flash)",
  平台和您一起分享手续费: "Partagez les frais ensemble",
  "*级": "{0}niveau",
  规则: "Régner",
  我的好友: "Amis",
  好友详情: "Détails de l'ami",
  获得好友佣金方案: "Programme de commission Get Friend",
  我的等级: "Mon niveau",
  我的邀请数据: "Mes données d'invitation",
  当前等级: "Niveau actuel",
  平台奖励您: "La plateforme vous récompense",
  最高可获取平台奖励: "Récompense maximale disponible",
  邀请规则: "Règles d'invitation",
  "邀请*级有效好友": "Invitez des amis valides de niveau {0}",
  好友等级: "Niveau ami",
  人: "Personnes",
  奖金派送: "Livraison en prime",
  平台奖励: "Récompense de la plateforme",
  "最终解释权归平台所有，若发现异常获取平台奖励，将会扣除所有的奖励，并且冻结账户，资产的损失将无法找回。":
    "Le droit d'interprétation finale appartient à la plate-forme. S'il s'avère que les récompenses de la plateforme sont obtenues de manière anormale, toutes les récompenses seront déduites, et le compte sera gelé, et ceux des avoirs ne seront pas récupérés.",
  "您的账户必须是有效账户，平台判定有效账户条件为（账户充值任何币种）最小* USDT的价值。":
    "Votre compte doit être un compte valide, et la plate-forme détermine que la condition du compte valide est (le compte est rechargé dans n'importe quelle devise) la valeur minimale de {0} USDT.",
  "您邀请的好友，必须是有效下级，平台判定有效下级为（账户充值任何币种）最小* USDT的价值。":
    "Les amis que vous invitez doivent être des subordonnés valides. La plate-forme détermine que les subordonnés valides sont (recharge de compte dans n'importe quelle devise) valeur minimale de {0} USDT.",
  "邀请人和被邀请者的账号不能同属于一个IP。":
    "Les comptes de l'invitant et de l'invité ne peuvent pas appartenir à la même IP.",
  "VIP等级由您邀请的*级好友的人数作为考核。":
    "Le niveau VIP est évalué par le nombre d'amis de haut niveau que vous invitez.",
  佣金成分: "Composante commission",
  收益统计: "Statistiques sur le revenu",
  昨日收益: "d'hier",
  月收益: "Mensuel",
  获取收益: "Revenu",
  "总收益：": "Total:",
  "*级好友": "{0}ami de niveau",
  理财购买: "Achat financier",
  期限: "Le terme",
  可用金额: "Montant disponible",
  预估收益: "Les revenus estimés",
  申购上限: "Limite d'abonnement",
  项目剩余: "Projet restant",
  "买入后预计*(SGT)开始计算收益。":
    "Attendez-vous à ce que {0}(SGT) commence à gagner.",
  计息日: "Date d'intérêt",
  申购日: "Date d'achat",
  到账日: "Date d'arrivée",
  到期自动续投: "Renouvellement automatique après expiration",
  申购: "Abonnement",
  搜索理财项目: "Rechercher des programmes financiers",
  超高年化随心选: "Choix libre",
  "自由选择理财币种，稳定超额收益":
    "Libre choix de la devise de gestion de fortune pour stabiliser les rendements excédentaires",
  理财总资产: "Montant de l'achat",
  累计收益: "Revenu cumulé",
  申购数量: "",
  立即购买: "Acheter maintenant",
  年化收益率: "AVR",
  理财订单: "Ordre financier",
  持有: "Tenir",
  申购份额: "Part d'abonnement",
  到账日期: "Date d'arrivée",
  申购成功: "L'abonnement est réussi",
  到期: "Maturité",
  是否选择做多: "Choisissez-vous de faire plus",
  "可用余额为0 不能操作":
    "Le solde disponible est de 0 et ne peut pas être utilisé",
  福利中心: "Cadeaux",
  奖励记录: "Enregistrement",
  我获取到的奖励: "Récompenses que j'ai eues",
  总价值: "Valeur totale",
  新手任务: "Tâche novice",
  身份认证: "Authentification",
  身份验证: "Authentification",
  去验证: "Vérifier",
  审核中: "À l'étude",
  已验证: "Vérifié",
  认证失败: "Authentification échouée",
  基础认证: "Certificat de base",
  "请注意认证信息一经验证不能修改，务必填写准确信息":
    "Veuillez noter que les informations d'authentification ne peuvent pas être modifiées une fois vérifiées, assurez-vous de remplir les informations correctes",
  "国家/地区": "Pays / région",
  请选择: "Choisissez s'il vous plaît",
  证件类型: "Type de certificat",
  证件编码: "Codage",
  身份证: "carte d'identité",
  护照: "Passeport",
  驾驶证: "Permis de conduire",
  请输入编码: "Veuillez entrer le code",
  名字: "Nom",
  请输入: "Entrez s'il vous plait",
  中间名: "Deuxième nom",
  选填: "Optionnel",
  姓氏: "nom de famille",
  中国: "Chine",
  身份上传: "Téléchargement d'identité",
  上传身份证: "Identifiant de téléchargement",
  "以上材料需要用JPG/JPEG/PNG格式上传，并且保证照片的清晰边角完整，亮度均匀。且大小不超过*M。":
    "Les documents ci-dessus doivent être téléchargés au format JPG/JPEG/PNormatet s'assurer que les bords et les coins clairs de la photo sont complets et que la luminosité est uniforme. Et la taille ne dépasse pas {0}M.",
  确定提交: "Confirmer la soumission",
  去认证: "Désauthentifier",
  挑战任务: "Mission défi",
  注册认证任务: "S'inscrire aux tâches de certification",
  完成注册认证即可领取:
    "Après avoir rempli le certificat d'inscription, vous pouvez le recevoir",
  领取奖励: "Recevoir le prix",
  新人豪礼: "Nouveau venu",
  "参与人数：": "Nombre de participants:",
  条件: "Condition",
  入金量: "Verser",
  完成: "Finir",
  任务奖励: "Récompenses de mission",
  距任务更新: "Mettre à jour à partir de la tâche",
  "条件：": "Condition:",
  活动规则: "Règle d'activité",
  奖励明细: "Détails de la récompense",
  已获得: "Obtenu",
  交易奖励: "Récompense de transaction",
  Win奖励: "Gagnez des récompenses",
  已领取: "Reçu",
  亏损金额超过: "Le montant de la perte dépasse",
  单笔开仓金额超过: "Le montant d'une seule position ouverte dépasse",
  交易量: "Commerce",
  待完成: "En attente",
  入金: "Verser",
  盈利金额超过: "Le montant du bénéfice dépasse",
  开仓金额: "Montant",
  开仓金: "Poste libre",
  盈利: "Profit",
  亏损: "perte",
  领取: "Recevoir",
  未领取: "Non acclamé",
  待领取: "En attente",
  再交易: "Re-négociation",
  即可获得: "Pour obtenir",
  领取成功: "Reçu avec succès",
  "1、所有的活动都会按照活动最后的时间进行统计收益过期后将无效。":
    "1. Toutes les activités seront comptées en fonction de la dernière fois de l'activité, et le résultat sera invalide après l'expiration.",
  "2、获得的收益会发放到您的赏金账户中，你可以随时根据您的需要进行兑换和提现。":
    "2. Les revenus obtenus seront distribués sur votre compte bounty, et vous pourrez les échanger et les retirer à tout moment selon vos besoins.",
  "3、获取的到的奖励币种类型根据任务按类型发放。":
    "3. Le type de devise de récompense obtenue sera émis en fonction du type de tâche.",
  "4、最终解释权归平台所有，若发现存在异常手段套利平台的任务奖金，平台有权冻结并且清除您获取的收益。":
    "4. Le droit d'interprétation finale appartient à la plate-forme. S'il s'avère qu'il existe des moyens anormaux d'arbitrage du bonus de tâche de la plateforme, la plateforme a le droit de geler et d'effacer le revenu que vous avez obtenu.",
  成长学院: "Centre d'aide",
  "区块链 & 加密货币": "Blockchain & Cryptocurrency",
  "您的加密货币一站式指南，我们带您开启加密货币之路。":
    "Your one-stop guide to cryptocurrencies, we take you on the road to cryptocurrencies.",
  "全仓合约定单的全部保证金。": "The full margin for a cross futures order.",
  "(账户余额+(浮动盈亏-手续费-过夜费)=净值/已用保证金*100":
    "(Balance + (Unrealized P&L - handling fee - overnight fee) = new worth / used margin * 100",
  "浮动盈亏会直接影响”可用保证金“，当未实现盈亏增加，可用保证金将会增加，未实现盈亏减少，可用保证金同样也会减少。":
    'The Unrealized P&L will directly affect the "available margin". When the unrealized profit and loss increases, the available margin will increase, and the unrealized profit and loss wilecrease, and the available margin will also decrease.',
  "账户余额-(已用保证金)+(浮动盈亏-手续费-过夜费)":
    "Balance - (used margin) + (Unrealized P&L - handling fee - overnight fee)",
  "注:可继续用于开仓的保证金。":
    "Note: Margin that can continue to be used for opening positions.",
  "账户余额+(浮动盈亏-手续费-过夜费)":
    "Balance + (Unrealized P&L - handling fee - overnight fee)",
  "注:当前的资金结余。": "Note: Current fund balance.",
  "指的是合约账户的全部余额，包含不可用余额。":
    "Refers to the entire balance of the futures account, including the unavailable balance.",
  "注:风险率越高，风险越低，风险率越低，风险越高。":
    "Note: The higher the risk rate, the lower the risk, and the lower the risk rate, the higher thisk.",
  该功能尚未开发: "This feature has not been developed",
  重置密码: "Reset Password",
  "请输入为8-20位，必须包含字母、数字和特殊字符":
    "Please enter 8-20 characters, must contain letters, numbers and special characters",
  修改成功: "Successfully modified",
  输入验证码: "Code",
  输入密码: "Password",
  详情说明: "Details",
  已售罄: "Sold out",
  剩余期限: "Deadline",
  限期: "Deadline",
  闪兑货币选择: "Flash currency selection",
  地区选择: "Region selection",
  "搜索国家/地区": "Search country",
  "身份信息已提交，将在*小时内审核完成":
    "Les informations d'identité ont été soumises et seront examinées dans {0} heures",
  "选择国家/地区": "Select country",
  "止盈价格需高于*": "Take Profit price must be higher than {0}",
  "止损价格需低于*": "Stop loss price must be lower than {0}",
  "止盈价格需低于*": "Take Profit price must be lower than {0}",
  "止损价格需高于*": "Stop loss price must be higher than {0}",
  教程详情: "Tutorial Details",
  请输入止损价: "Please enter a stop loss price",
  活期: "Flexible",
  赎回后立即到账: "Withdraw",
  赎回: "Redemption",
  赎回理财: "Redemption",
  是否赎回当前的理财订单:
    "Whether to redeem the current wealth management order",
  维护: "Maintenance",
  "系统正在维护中……": "The system is under maintenance...",
  合约: "Futures",
  闪电兑换: "Flash Swap",
  流水挖矿: "Cloud Mining",
  邀请豪礼: "Invitation",
  计算器: "Calculator",
  最新价: "Last Price",
  涨跌幅: "Change",
  关注币种添加自选: "Follow the currency",
  一键添加自选: "Add",
  全标已读: "Read all",
  无消息: "No news",
  "暂时还没有收到任何消息通知哦!": "No message received!",
  没有更多数据: "No more",
  闪兑: "Swap",
  从: "From",
  "可用余额：": "Balance：",
  至: "To",
  预览兑换结果: "Preview",
  闪兑规则: "Rules",
  "市场闪兑可能变动，请以实际到账的金额数量为准。":
    "The market flash exchange may change, please refer to the actual amount received.",
  "对汇兑率由第三方制定，由于兑换成本以及市场波动，您兑换的汇率可能会高于市场的汇率，请仔细确认后进行操作。":
    "The exchange rate is set by a third party. Due to exchange costs and market fluctuations, the exchange rate you exchange may be higher than the market exchange rate. Please confirm carefully beforroceeding.",
  "平台对每笔汇兑收取大约*%的手续费，用于支付在交易所兑换成本。":
    "The platform charges a handling fee of about {fee}% for each exchange, which is used tafor the exchange cost on the exchange.",
  确认汇兑: "Confirm",
  您预估得到: "Estimation",
  汇兑: "Flash Swap",
  汇兑比例: "Proportion",
  刷新: "Refresh",
  兑换: "Flash Swap",
  没有更多了: "No more",
  搜索币种: "Search",
  可用: "Available",
  我知道了: "Know",
  最新价格: "Latest price",
  确认: "Confirm",
  最大: "Max",
  "风险率(%)": "Risk(%)",
  持仓: "Position",
  当前委托: "Order",
  合作交易历史记录: "History",
  重置: "Reset",
  余额: "Balance",
  现货账户: "Compte de financement",
  合约账户: "Futures",
  WIN账户: "Win",
  赏金账户: "Gift",
  总资产折合: "Asset equivalent",
  今日收益: "Today's",
  充币: "Deposit",
  提币: "Withdraw",
  账户权益: "Account equity",
  "数量/类别": "Amount/Type",
  全部币种: "All coins",
  全部类型: "All types",
  账单信息: "Coin",
  理财赎回: "Financial redemption",
  购买理财: "Financial buy",
  收入: "Income",
  支出: "Expenditures",
  到: "To",
  资产划转: "Transfer",
  "最少*": "Min*",
  "可用资产：": "Balance",
  确认划转: "Transfer",
  "只有将资产划转至对于的账户才可以进行交易，账户间的划转不收取手续费。":
    "Transactions can only be performed by transferring assets to the correspondinccount, and no handling fee will be charged for transfers between accounts.",
  币种账户选择: "Account choice",
  选择账户: "Account choice",
  划转详情: "Transfer info",
  划转明细: "Transfer info",
  收入账单: "Income info",
  支出账单: "Expenditures info",
  金额: "Amount",
  总收益: "Total",
  佣金: "Award",
  用户名: "username",
  "已领取：": "Received：",
  "未领取：": "Not received：",
  "请选择国家/地区": "Please select country/region",
  请上传身份信息: "Please upload ID",
  请选择证件类型: "Please select document type",
  请填写证件编码: "Please fill in the ID number",
  请填写名字: "Please fill in name",
  请填写姓氏: "Please enter last name",
  单向持仓: "One-way holding",
  投资金额: "Amount",
  天: "day",
  请输入手机号: "Phone",
  搜索: "Search",
  搜索历史: "Search history",
  热门推荐: "Hot",
  "《Xspace Earn协议》": "《Xspace Earn Protocol》",
  我已了解并同意: "I understand and agree",
  协议: "protocol",
  Xspace官方中文交流群: "Xspace Official Chinese Group",
  Xspace官方英文交流群: "Xspace Official English Group",
  预计维护至: "Expected to",
  更多功能: "More",
  下载APP: "Download",
  理财: "Financial",
  推荐: "Recommend",
  Telegram官方中文频道: "Telegram official Chinese channel",
  Telegram官方英文频道: "Telegram official English channel",
  官方邮箱: "Official email",
  客服邮箱: "Customer Service Email",
  上述信息最终解释权归官方所有:
    "The final interpretation right belongs to the official",
  IOS版下载: "Download for IOS",
  Android版下载: "Download for Android",
  "手续费=买入手续费+资金费率+卖出手续费":
    "Fee = Buying fee + Funds fee + Sell fee",
  资金划转: "Transfer",
  止盈: "TP",
  止损: "SL",
  自动平仓: "Automatic Close",
  委托挂单: "Entrusted pending order",
  买: "Buy",
  卖: "Sell",
  "买入/做多": "Buy/Long",
  "卖出/做空": "Sell/Short",
  详情: "Details",
  浮动涨跌: "Ups&Downs",
  最小: "Min",
  充币数量: "Montant de la recharge",
  请输入充币数量: "Montant de la recharge",
  支付截图: "Capture d'écran de paiement",
  提交: "Nous faire parvenir",
  上传驾驶证: "Télécharger le permis de conduire",
  上传护照: "Télécharger le passeport",
  加载中: "Chargement",
  上传成功: "Succès",
  充值历史: "Histoire",
  合约卖出手续费: "Frais de contrat",
  合约买入手续费: "Frais de contrat",
  系统加款: "Complément système",
  系统减款: "Réduction du système",
  合约资金费率: "Taux de contrat",
  佣金分成: "Partage des commissions",
  U本位合约: "Contracter",
  资产管理: "Les atouts",
  APP下载: "Téléchargement de l'application",
  全球领先的数字理财平台:
    "La première plateforme de gestion de patrimoine numérique au monde",
  "即刻交易比特币、以太坊等上百种数字资产":
    "Échangez instantanément des centaines d'actifs numériques tels que Bitcoin et Ethereum",
  "24H涨跌幅": "Changement 24H",
  查看更多行情: "Voir plus de devis",
  近24小时成交量: "Volume des dernières 24 heures",
  "提供数百种币币和合约交易对，以满足多样化的交易需求。 平台在200个国家和地区中有超过2千万用户，是全球领先的数字资产服务平台。":
    "Fournissez des centaines de paires de devises et de contrats pour répondre à des besoins commerciaux diversifiés. La plateforme compte plus de 20 millions d'utilisateurs dans 200 pays et régions, et est la première plateforme de services d'actifs numériques au monde.",
  用户国家分布: "Répartition des pays utilisateurs",
  用户数: "Numéro d'utilisateur",
  交易对: "Paire de négociation",
  服务支持: "Service après vente",
  "随时随地，多平台终端交易":
    "N'importe quand, n'importe où, transactions sur terminaux multiplateformes",
  "多终端完美兼容，随时满足各种场景的交易需求。":
    "Le multi-terminal est parfaitement compatible et peut répondre à tout moment aux besoins de transaction de divers scénarios.",
  随时查看实时行情: "Voir les cotations en temps réel à tout moment",
  "轻松买卖BTC，ETH，DOGE和其他数字资产":
    "Achetez et vendez facilement BTC, ETH, DOGE et d'autres actifs numériques",
  获取您关注的加密货币价格变化预警:
    "Recevez des alertes sur les changements de prix des crypto-monnaies qui vous intéressent",
  "查看比特币现货、期货、期权价格":
    "Voir Bitcoin spot, futures, prix des options",
  比较各交易所加密货币价格:
    "Comparez les prix des crypto-monnaies sur les échanges",
  开启您的数字货币之旅: "Commencez votre voyage vers la monnaie numérique",
  快捷购买数字货币: "Achetez rapidement de la monnaie numérique",
  "使用多种支付方式交易数字货币，安全快捷":
    "Utilisez une variété de méthodes de paiement pour échanger des devises numériques, en toute sécurité et rapidement",
  最优的交易费率: "meilleur taux de transaction",
  "优惠的交易费率，富有竞争力的VIP权益，享受最优品质的服务":
    "Tarifs de transaction préférentiels, droits VIP compétitifs, profitez de la meilleure qualité de service",
  可信赖的安全保障: "Sécurité fiable",
  "我们复杂的安全措施和SAFU基金保护您的数字资产免受所有风险。":
    "Nos mesures de sécurité sophistiquées et nos fonds SAFU protègent vos actifs numériques de tous les risques.",
  交易: "Échanger",
  币币市场: "Marché des devises",
  "24H成交量": "Volume 24h",
  交易所: "Échanger",
  "24H最高": "24H haute",
  "24H最低": "24H bas",
  永续合约: "Contrat perpétuel",
  日涨跌: "Changer",
  交易深度: "profondeur des transactions",
  "资产(合约)": "Actifs (contrats)",
  历史仓位: "Historique",
  兑换记录: "Enregistrement d'échange",
  类型: "Taper",
  充值记录: "Recharger l'enregistrement",
  划转记录: "Dossier de transfert",
  类别: "Catégorie",
  历史账单: "Historique",
  在线充值: "Recharger",
  安全设置: "Les paramètres de sécurité",
  用于账户登录使用: "Pour la connexion au compte, utilisez",
  用户提现时安全验证使用:
    "Vérification de la sécurité et utilisation lorsque les utilisateurs retirent de l'argent",
  验证: "Vérifier",
  万: "Dix mille",
  随时随地开启交易: "Échanger. Partout.",
  "*货币交易所的所有功能尽在你的手中。":
    "Toutes les fonctions de l'échange de devises {0} sont entre vos mains.",
  "下载*货币交易所APP。": "Téléchargez l'application de change {0}.",
  下载自: "Télécharger à partir de",
  内测版: "Bêta fermée",
  下载: "Télécharger",
  扫码下载: "Scannez pour télécharger",
  设置您的资产密码: "Configurez votre mot de passe d'actif",
  法币: "Fiat",
  我要买: "Achat",
  我要卖: "Vendre",
  请输入金额: "Veuillez entrer le montant",
  汇率: "Taux de change",
  获得: "Obtenir",
  支付通道: "Canal de paiement",
  收款通道: "Canal de collecte",
  "出售过程需要务必确认好您的收款方式为本人。":
    "Au cours du processus de vente, vous devez confirmer que votre mode de paiement est bien le vôtre.",
  当前法币暂不支持交易对可尝试前往提现:
    "La devise légale actuelle ne prend pas en charge la paire de trading, vous pouvez essayer de retirer",
  前往提现: "Aller encaisser",
  该法币暂无通道:
    "Il n'y a actuellement aucun canal pour cette monnaie fiduciaire",
  "正在出售中，请耐心等待": "En vente, merci de patienter",
  请选择支付通道: "Veuillez sélectionner un canal de paiement",
  请选择方式: "Veuillez sélectionner une méthode",
  法币历史: "Histoire de Fiat",
  买币: "Acheter des pièces",
  卖币: "Vendre des pièces",
  失败: "échouer",
  已完成: "Complété",
  未付款: "Non payé",
  待审核: "En attendant l'examen",
  打款中: "Payant",
  订单详情: "Détails de la commande",
  联系客服: "Contactez le service à la clientèle",
  到账金额: "Montant reçu",
  通道: "Allée",
  收款人: "Bénéficiaire",
  收款账户: "Comptes débiteurs",
  "订单出售失败，请查下方失败原因":
    "La commande n'a pas pu être vendue, veuillez vérifier la raison de l'échec ci-dessous",
  失败原因: "Raison de l'échec",
  您还未进行付款: "Vous n'avez pas effectué de paiement",
  您已成功购买: "Vous avez acheté avec succès",
  已取消订单: "Commande annulée",
  "订单正在审核中，请耐心等待":
    "La commande est en cours d'examen, veuillez patienter",
  您已成功出售: "vous avez vendu avec succès",
  "订单正在打款中，请耐心等待":
    "La commande est en cours de paiement, merci de patienter",
  "支付过程需要您前往其他的平台进行支付订单，请注意信息安全。":
    "Le processus de paiement vous oblige à vous rendre sur d'autres plates-formes pour payer les commandes, veuillez faire attention à la sécurité des informations.",
  当前法币暂不支持交易对可尝试前往充值:
    "La monnaie fiduciaire actuelle ne prend pas en charge les paires de trading, vous pouvez essayer de recharger",
  前往充值: "Aller recharger",
  购买: "Acheter",
  订单号: "Numéro",
  单价: "Prix ​​unitaire",
  到账数量: "Montant à comptabiliser",
  "当前存在未付的订单，是否继续发起新的支付订单？":
    "Il y a actuellement des commandes impayées, souhaitez-vous continuer à initier un nouvel ordre de paiement ?",
  继续支付: "Continuer à payer",
  重新下单: "Réorganiser",
  是否确定出售: "Êtes-vous sûr de vendre",
  "确定出售后，平台将分配给买家，请耐心等待平台的撮合。":
    "Une fois la vente confirmée, la plate-forme sera attribuée à l'acheteur, veuillez attendre patiemment que la plate-forme corresponde.",
  出售: "Vendre",
  收款方式: "Mode de paiement",
  订单已生成: "La commande a été générée",
  取消订单: "annuler la commande",
  请在: "s'il vous plaît à",
  内完成付款: "paiement complet dans",
  "离开平台，登录您指定的支付，转账到卖家的以下账户，并务必在付款中备注：":
    "Quittez la plateforme, connectez-vous au paiement que vous avez spécifié, transférez sur le compte du vendeur ci-dessous et assurez-vous de noter dans le paiement :",
  "若付款时未进行备注，卖家将无法确认收款，造成资产损失无法找回。":
    "Si aucune remarque n'est faite au moment du paiement, le vendeur ne pourra pas confirmer le paiement, entraînant la perte d'avoirs non récupérables.",
  "未在规定的时间内付款，订单都将被取消。":
    "A défaut de paiement dans les délais impartis, la commande sera annulée.",
  姓名: "Nom",
  收款姓名: "Le nom du bénéficiaire",
  开户支行: "Branche d'ouverture de compte",
  银行卡号: "Numéro de carte bancaire",
  "付款后，返回本平台": "Après paiement, retournez sur cette plateforme",
  "请务必点击下方“我已完成付款，通知卖家”按钮":
    "Assurez-vous de cliquer sur le bouton “J'ai effectué le paiement, informez le vendeur” ci-dessous",
  未点击卖家不会放款:
    "Si vous ne cliquez pas, le vendeur ne débloquera pas l'argent",
  交易条款: "Conditions de la transaction",
  "购买资金来源，必须合法安全的资金，方可交易":
    "En achetant la source des fonds, vous devez disposer de fonds légaux et sûrs avant de pouvoir négocier",
  "不允许诈骗、传销、赌博或者其他非法资金交易":
    "La fraude, les systèmes pyramidaux, les jeux d'argent ou autres transactions financières illégales ne sont pas autorisés",
  "交易完成后，出现资金风险，被冻结或者涉嫌欺诈、传销、赌博的资金，我方将不在向买方放U，并给予退款":
    "Une fois la transaction terminée, il existe un risque de fonds, gelés ou suspectés de fraude, de systèmes pyramidaux, de fonds de jeu, nous ne libérerons pas U à l'acheteur et nous vous rembourserons",
  "已付款，通知卖家": "Payé, aviser le vendeur",
  "买方当日累计取消*笔订单，将会取消当日购买功能。确定取消该订单吗？":
    "Si l'acheteur annule {0} commandes le même jour, la fonction d'achat le jour même sera annulée. Voulez-vous vraiment annuler cette commande ?",
  添加收款方式: "Ajouter un moyen de paiement",
  是否删除此收款方式: "Si vous souhaitez supprimer ce mode de paiement",
  删除: "Effacer",
  请选择法币: "Veuillez sélectionner la devise fiduciaire",
  机构名称: "Nom de l'institution",
  请选择机构: "Veuillez sélectionner un établissement",
  "当您出售数字货币时，您选择的收款方式将向买方展示，请确认填写无误。":
    "Lorsque vous vendez de la monnaie numérique, le mode de paiement que vous avez sélectionné sera affiché à l'acheteur, veuillez confirmer qu'il est correctement rempli.",
  请选择银行: "Veuillez sélectionner une banque",
  请输入姓名: "Veuillez saisir votre nom",
  账号: "Compte",
  请输入账号: "Veuillez saisir le compte",
  收款码: "Code de reçu",
  "银行账号/卡号": "Numéro de compte/carte bancaire",
  "请输入银行账号/卡号": "Veuillez saisir le numéro de compte/carte bancaire",
  "开户支行（选填）": "Agence d'ouverture de compte(facultatif)",
  请输入开户支行: "Veuillez saisir la branche d'ouverture de compte",
  "加入*官方频道": "Rejoignez {0} Chaîne officielle",
  关于: "Sur",
  条款: "Termes",
  其他: "Autre",
  成功: "Succès",
  等待: "Attendez",
  作废: "Annuler",
  确认付款: "Aonfirmer le paiement",
  "是否已完成付款？若确认付款后，商家将会在*分内进行确认是否收到付款。":
    "Le paiement a-t-il été effectué ? Si le paiement est confirmé, le commerçant confirmera si le paiement a été reçu dans les {0} minutes.",
  最大金额: "Quantité maximale",
  最小金额: "Montant minimal",
  付款: "Paiement",
  法币充值: "Recharge de monnaie Fiat",
  法币提现: "Retrait Fiat",
  待支付: "Être payé",
  已支付: "Payé",
  商户名: "Marchand",
  当前没有添加支付方式: "Il n'y a actuellement aucun mode de paiement ajouté",
  添加后再出售: "Ajouter pour vendre",
  新人大礼包: "Cadeau nouveau venu",
  注册即可领取: "Enregistrer obtenir",
  立即领取: "Obtenez-le maintenant",
  不再提示: "Ne rappelle plus",
  "该奖励需在APP中领取，请下载APP":
    "La récompense doit être collectée dans l'APP, veuillez télécharger l'APP",
  去交易: "Échanger",
  期权交易: "Négociation d'options",
  交易额: "Montant de la transaction",
  可用额度: "Quota disponible",
  交易周期: "Cycle de négociation",
  看涨: "Monter",
  看跌: "Tomber",
  当前持有: "Avoirs actuels",
  胜率: "Taux de réussite",
  "盈利/亏损数": "Perte de profit",
  累计实现盈亏: "Gains et pertes cumulés",
  秒: "Seconde",
  分: "Minute",
  小时: "Heure",
  天: "Journées",
  周: "La semaine",
  下单时间: "Temps de commande",
  剩余时间: "Temps restant",
  买入价: "Prix ​​d'achat",
  结算价: "Prix ​​de règlement",
  实现盈利: "Profit",
  结算时间: "Délai de règlement",
  期权: "Choix",
  新手教程: "Tutoriel du débutant",
  我的订单: "Ordre",
  赔率: "Chances",
  全部订单: "Tous les ordres",
  持有订单: "Maintenir la commande",
  历史订单: "Historique des commandes",
  输入交易额度: "Entrez le montant",
  选择交易周期: "Période de sélection",
  去注册: "S'inscrire",
  冻结: "Gel",
  期权支出: "Paiement des options",
  期权收入: "Revenu d'options",
  用户提现: "Retrait de l'utilisateur",
  "是否购买？": "Veux-tu acheter?",
  购买成功: "Achat réussi",
  请签名: "Soumis",
  提交签名: "Soumettre la signature",
  清空签名: "Signature claire",
  签名审核中: "Examen des signatures",
  已提交: "Soumis",
  扫一扫下载APP: "Scannez et téléchargez l'application",
  新手领取大礼包: "Les débutants reçoivent la fête",
  注册实名即送彩金: "Bonus d'inscription et de nom réel",
  交易总额: "Transaction totale",
  资产不足: "Actifs insuffisants",
  "Win账户的资产不足，可从现货账户划转至此账户":
    "Les actifs du compte Win sont insuffisants et peuvent être transférés du compte de financement vers ce compte",
  Win: "Win",
  在线充值: "Recharge en ligne",
  比赛: "Concours",
  未开始: "Pas commencé",
  赛程: "Programme",
  赛果: "Résultat",
  已结束: "Plus de",
  让球: "Asian handicap",
  进球数: "Over/Under",
  大: "Over",
  小: "Under",
  胜负平: "Win/Lose",
  和局: "Jeu tiré",
  投注: "Pari",
  下注金额: "Montant du pari",
  下注: "Pari",
  阵容: "Tableau de bataille",
  分析: "Analyser",
  输入下注金额: "Entrer",
  下注成功: "Pari réussi",
  投注记录: "Record de paris",
  未结算: "Pas de règlement",
  已结算: "Colonisé",
  流水: "Montant",
  输赢: "Gagner ou perdre",
  赛时: "Temps de jeu",
  下注时间: "Temps de pari",
  足彩竞猜: "Quizz sur le foot",
  查看详情: "Vérifier",
  输: "Perdre",
  赢: "Gagner",
  主: "Équipe à domicile",
  客: "Équipe extérieure",
  主胜: "L'équipe à domicile gagne",
  客胜: "L'équipe à l'extérieur gagne",
  平: "Dessiné",
  已延期: "Reporté",
  账号异常: "Exception de compte",
  全场独赢: "1x2",
  全场让球: "Handicap",
  全场大小: "Over/Under",
  总进球: "Objectifs totaux",
  拍摄照片要求: "Exigences relatives aux photos",
  标准拍摄: "Tir standard",
  边框缺失: "Bordure manquante",
  照片模糊: "La photo est floue",
  闪光强烈: "Flash puissant",
  上传手持证件照: "Télécharger des documents portables",
  上传证件照: "Télécharger une photo d'identité",
  换一张: "Changer un",
  出生日期: "Date de naissance",
  请选择出生日期: "Veuillez sélectionner la date de naissance",
  "输入下方正确的图形验证后，获取邮箱验证码进行注册":
    "Après avoir entré la vérification graphique correcte ci-dessous, obtenez le code de vérification par e-mail pour l'enregistrement",
  "您还剩余*次认证次数，超出次数将无法继续认证":
    "Il vous reste {0} certifications, après quoi vous ne pourrez plus poursuivre la certification",
  上半场: "Première moitié",
  下半场: "Deuxième partie",
  独赢: "1x2",
  上半场独赢: "Première moitié 1x2",
  下半场独赢: "Deuxième partie 1x2",
  上半场让球: "Première moitié Handicap",
  下半场让球: "Deuxième partie Handicap",
  上半场大小球: "Première moitié Over/Under",
  下半场大小球: "Deuxième partie Over/Under",
  波胆: "Correct Score",
  上半场波胆: "Première moitié Correct Score",
  下半场波胆: "Deuxième partie Correct Score",
  单双: "Odd/Even",
  上半场单双: "Première moitié Odd/Even",
  下半场单双: "Deuxième partie Odd/Even",
  总进球: "Total Goal",
  上半场总进球: "Première moitié Total Goal",
  下半场总进球: "Deuxième partie Total Goal",
  单: "Odd",
  双: "Even",
  中场: "Milieu de terrain",
  "注意：手持证件照请按照此示例图在白纸上书写文字并与证件一起拍摄":
    "Remarque : veuillez suivre cet exemple d'image pour écrire du texte sur du papier blanc et prendre la photo avec la carte d'identité.",
  "近期发现大量作弊账户，对一批违规账户进行了惩罚。如果有误判为违规账户，请联系在线客服。":
    "Récemment, un grand nombre de comptes de triche ont été découverts et un certain nombre de comptes illégaux ont été punis. S'il y a une erreur de jugement en tant que compte illégal, veuillez contacter le service client en ligne.",
  最小下注金额: "Montant de pari minimum",
  参与活动最小下注金额: "Montant de mise minimum pour participer à l'événement",
  记住密码: "Rappelles toi",
  比分: "Score",
  "您还未登录，请先登录": "Veuillez vous connecter",
  立即登录: "Connexion",
  下注限额: "Limite de pari",
  可赢金额: "Peut gagner",
  闪兑详情: "Détails Flash",
  大小球: "Over/Under",
  "由于汇率原因，下注金额和实际下注金额会有误差，请以订单为准。":
    "En raison du taux de change, il y aura une différence entre le montant du pari et le montant réel du pari, veuillez vous référer à la commande.",
  开赛时间: "Heure de début",
  足球收入: "Revenus du football",
  足球支出: "Dépenses de football",
  活动详情: "Détails de l'activité",
  为世界杯喝彩: "Bravo pour la coupe du monde",
  我的竞猜: "Mon",
  "竞猜比赛、有机会瓜分*USDT":
    "Devinez le jeu et courez la chance de partager {0}USDT",
  "瓜分*USDT": "Partager {0}USDT",
  距离活动结束还有: "Fin de parcours",
  我的门票: "Mon billet",
  竞猜结束时间: "Devinez l'heure de fin",
  猜比分: "Devinez le score",
  "福利派送中，完成任务即可获取门票":
    "La distribution d'aide sociale est en cours, terminez la tâche pour obtenir des billets",
  "完成如下任务，可获对应数量门票的参与竞赛":
    "Effectuez les tâches suivantes, vous pouvez obtenir le nombre correspondant de billets pour participer au concours",
  时: "Heure",
  活动: "Activité",
  竞猜记录: "Enregistrement de deviner",
  结果: "Résultat",
  任务: "Tâche",
  去邀请: "Inviter",
  "每场比赛的比分竞猜，参与竞猜可瓜分$*美金的奖励。":
    "Le score de chaque match est de {0} dollars.",
  "参与竞猜需要门票，门票可按照平台的任务进行获得。":
    "La participation au quiz nécessite des tickets, qui peuvent être obtenus en fonction des tâches de la plateforme.",
  "竞猜成功后，把竞猜结果的截图发送给客服，客服会把奖金划入您的现货账户，你可以立即提取。":
    "Une fois le pari réussi, envoyez une capture d'écran des résultats du pari au service client. Le service client transférera les gains sur votre compte de fonds, et vous pourrez les retirer immédiatement.",
  "禁止任何作弊行为、如果发现作弊行为，奖励无效。":
    "Toute tricherie est interdite et les récompenses seront annulées si une tricherie est constatée.",
  "完成任务后，点击咨询客服获得门票。":
    "Après avoir terminé la tâche, cliquez sur Consulter le service client pour obtenir le ticket.",
  继续猜: "Continue à deviner",
  总单数: "Total singulier",
  赛事筛选: "Projection d'événements",
  球队筛选: "Sélection de l'équipe",
  总金额: "Montant forfaitaire",
  总流水: "Changement total",
  派奖金额: "Montant du bonus",
  下注单数: "Pari nombre impair",
  利润: "Profit",
  更多福利: "Bien-être",
  我的奖金: "Ma prime",
  未认证: "Non certifié",
  总量: "Total",
  或: "Ou",
  模拟交易: "Commerce de démonstration",
  体验账户不可操作: "Le compte d'expérience est inutilisable",
  世界杯比分竞猜: "Devinez le score",
  "领*USDT起": "À partir de {0}USDT",
  消息: "Informations",
  滚球: "Roulez!",
  是: "C'est exact.",
  不是: "- Non.",
  当前余额: "Solde actuel",
  KOL招募: "Recrutement KOL",
  本月净输赢: "Gain/perte net pour le mois",
  本月佣金: "commissions du mois",
  佣金比例: "Taux de commission",
  活跃人数: "numéro actif",
  新增下级: "Ajouter un subordonné",
  登录人数: "nombre de connexions",
  首存人数: "Nombre de premiers déposants",
  数据分析: "l'analyse des données",
  人数: "nombre de personnes",
  新注册存款金额: "Nouveau montant du dépôt enregistré",
  老用户存款金额: "Montant du dépôt de l'ancien utilisateur",
  首存金额: "Montant du premier dépôt",
  快捷入口: "Entrée rapide",
  成员管理: "gestion des membres",
  财务报表: "États financiers",
  分红报表: "Rapport de dividendes",
  订单记录: "enregistrement de commande",
  VIP专享: "Exclusivité VIP",
  推广工具: "outil promotionnel",
  计算规则: "Règles de calcul",
  账变明细: "Détails du changement de compte",
  成员: "membre",
  下级概览: "Aperçu subordonné",
  下级成员总计: "Membres subordonnés Total",
  本月新增: "nouveau ce mois-ci",
  本月活跃会员: "Membre actif du mois",
  今日活跃会员: "Membres actifs aujourd'hui",
  本月有效活跃: "actif ce mois-ci",
  活跃成员占比: "Proportion de membres actifs",
  本月活跃: "actif ce mois-ci",
  今日活跃: "actif aujourd'hui",
  下级成员: "membre junior",
  会员账号: "compte membre",
  统计时间: "Heure des statistiques",
  筛选: "filtre",
  存款: "dépôt",
  取款: "retirer de l'argent",
  总输赢: "gain ou perte total",
  是否有效用户: "Est-ce un utilisateur valide",
  最近登录时间: "heure de la dernière connexion",
  否: "non",
  开始时间: "Heure de départ",
  结束时间: "Heure de fin",
  提取: "extrait",
  总盈亏: "profits et pertes totaux",
  净盈亏: "résultat net",
  分红: "dividendes",
  概览: "Aperçu",
  月度详细数据: "Données mensuelles détaillées",
  未发放: "non délivré",
  活跃用户: "utilisateur actif",
  有效新增会员: "Ajouter efficacement de nouveaux membres",
  冲正后净输赢: "Gain ou perte net après le rinçage",
  上月结余: "Solde du mois dernier",
  净输赢: "gains/pertes nets",
  "系统每日新加坡时间1:00更新一次报表":
    "Le système met à jour le rapport une fois par jour à 1: 00 heure de Singapour",
  "报表中数据、总输赢、净输赢中正数表示代理方盈利、负数表示代理方亏损":
    "Les nombres positifs dans les données, les gains et pertes totaux et les gains et pertes nets dans le rapport indiquent le profit de l'agent, et les nombres négatifs indiquent la perte de l'agent.",
  "佣金数据每天进行更新，仅供参考，并不做实际佣金派发标准":
    "Les données de commission sont mises à jour quotidiennement et sont fournies à titre indicatif uniquement, et non la norme de distribution de commission réelle",
  选择时间: "période de sélection",
  足球: "Football",
  投注金额: "montant du pari",
  有效订单: "commande valide",
  下级账户: "Compte subordonné",
  待成交: "accord en attente",
  下单金额: "montant de la commande",
  订单内容: "contenu de la commande",
  秒数: "secondes",
  联赛: "la Ligue",
  队伍: "équipe",
  比赛时间: "Temps de compétition",
  玩法: "comment jouer",
  等级规则表: "Tableau des règles de notation",
  等级: "grade",
  活跃会员: "membre actif",
  最新活跃: "dernier actif",
  额外佣金: "commission supplémentaire",
  "每月按照对应等级的增长标准与奖励制度执行，只可享受一个等级奖励。":
    "La norme de croissance et le système de récompense du niveau correspondant sont mis en œuvre chaque mois, et une seule récompense de niveau peut être appréciée.",
  渠道生成: "génération de canaux",
  创建: "créer",
  渠道名称: "nom du canal",
  注册人数: "nombre d'inscrits",
  浏览人数: "Les spectateurs",
  构建状态: "état de construction",
  禁用: "désactivée",
  启用: "activer",
  查看: "Vérifier",
  创建渠道: "créer un canal",
  创建成功: "créé avec succès",
  操作成功: "Opération réussie",
  渠道详情: "Détails de la chaîne",
  邀请码: "Code d'invitation",
  访问人数: "Nombre de visiteurs",
  渠道地址: "adresse du canal",
  我的福利: "mes avantages",
  充值福利: "Avantages de la recharge",
  当前流水: "flux de courant",
  如何参与: "comment participer",
  币种充值: "Recharge de devises",
  充值福利中领取福利: "Bénéficiez des prestations complémentaires",
  "规则：充值福利自愿领取，有效期为充值后的24小时内，过期无效，领取后将暂时锁定提现功能，当流水达到后即可解锁提现。":
    "Règles : l'avantage de recharge est volontaire et la période de validité est de 24 heures après la recharge. Il sera invalide après la date d'expiration. Après l'avoir reçu, la fonction de retrait d'espèces sera temporairement verrouillée et le retrait d'espèces pourra être débloqué une fois le chiffre d'affaires atteint.",
  失效日期: "date d'expiration",
  "暂无福利领取，充值后领取":
    "Aucun avantage à recevoir pour le moment, recevoir après recharge",
  参与: "participer",
  充值赠送: "Cadeau de recharge",
  "领取*%的赠送": "Recevez {0} % de cadeau",
  去领取: "collecter",
  VIP奖励: "Récompenses VIP",
  "当前可领取*USDT，是否确认领取":
    "Peut recevoir {0}USDT actuellement, confirmez-vous la réclamation ?",
  "领取后将临时锁定提现功能，当您的流水到达*USDT后即可解除锁定":
    "Après avoir réclamé, la fonction de retrait sera temporairement verrouillée et le verrou pourra être déverrouillé lorsque votre chiffre d'affaires atteindra {0} USDT",
  充值送大礼: "Rechargez pour obtenir un gros cadeau",
  "存入越多，送越多！": "Plus vous déposez, plus vous gagnez !",
  无效: "invalide",
  有效: "efficace",
  总存金额: "montant total du dépôt",
  提示: "indice",
  "总输赢，净输赢中正数表示平台盈利，负数表示亏损，每天数据只做参考，并不做实际佣金派发标准。":
    "Les nombres positifs dans les gains et pertes totaux et les gains et pertes nets indiquent les bénéfices de la plate-forme, et les nombres négatifs indiquent les pertes.Les données quotidiennes sont uniquement à titre de référence et ne servent pas de norme réelle de distribution des commissions.",
  "净盈亏：总盈亏-用户返水":
    "Bénéfice et perte nets : bénéfice et perte totaux - rabais utilisateur",
  盈利方: "Fête rentable",
  代理: "agissant",
  客户: "client",
  平局: "dessiner",
  平台: "Plate-forme",
  "已提交审核，请耐心等待": "Soumis pour examen, veuillez patienter",
  充值日期: "date de recharge",
  平台本月总输赢: "Total des gains et des pertes de la plateforme ce mois-ci",
  KOL招募合作: "Coopération de recrutement KOL",
  "平台现在开放【KOL招募活动】，只要您有社群媒体号，就可以和平台享受分红一次性推广客户，就可以享受终生收益。":
    "La plateforme est maintenant ouverte [KOL Recruitment Event], tant que vous avez un compte sur les réseaux sociaux, vous pouvez profiter d'un bonus unique avec la plateforme pour promouvoir les clients, et vous pouvez profiter d'avantages à vie.",
  级别: "niveau",
  平台利润返佣: "Remise sur les bénéfices de la plateforme",
  佣金案例: "Cas de commission",
  交易项目: "élément de transaction",
  "期权交易、合约交易、足球游戏":
    "Négociation d'options, négociation de contrats, matchs de football",
  报名方式: "modalités d'inscription",
  点击KOL招募报名: "Cliquez sur l'inscription au recrutement KOL",
  "欢迎加入我们的团队，平台全面扶持您建立属于自己的用户体系，最高可得*的佣金，我们期待您加入。":
    "Bienvenue dans notre équipe, la plateforme vous aide pleinement à établir votre propre système d'utilisateurs, et vous pouvez obtenir la commission la plus élevée{0}, nous nous réjouissons de votre adhésion.",
  输入联系方式: "Entrez les informations de contact",
  最低活跃人数: "Nombre actif minimum",
  "如：本月活跃人数≥*并且本月平台总输赢≥*USDT，您属于等级*，即可得到*%的佣金。":
    "Par exemple : le nombre d'utilisateurs actifs ce mois-ci ≥ {0} et le gain ou la perte total de la plateforme ce mois-ci ≥ {1}USDT, vous appartenez au niveau {2}, vous pouvez toucher {3}% de commission.",
  比分竞猜: "Concours de points",
  豪礼相赠: "Cadeau de Howie",
  足球活动: "Activité de football",
  圣诞节活动: "Activités de Noël",
  "您参加了活动，临时锁定提现功能，还需*USDT流水就可以解除锁定。":
    "Vous avez participé à l'événement, verrouillez temporairement la fonction de retrait, et vous avez besoin d'un flux usdt {0} pour déverrouiller.",
  剩余流水: "Débit résiduel",
  助力足球: "Aide au football",
  佣金累计: "Commission totale",
  有效投注: "Pari valide",
  今日: "Aujourd'hui",
  今日返水: "Remise aujourd'hui",
  VIP返水: "Rabais VIP",
  返水记录: "Enregistrement de remise",
  成员信息: "Informations sur les membres",
  基本信息: "Informations de base",
  钱包余额: "Solde du portefeuille",
  投注信息: "Informations sur les paris",
  返水: "Rabais",
  总下注: "Mise totale",
  今日输赢: "Gagner ou perdre aujourd'hui",
  下注动态: "Dynamique des paris",
  返水奖励: "Prime de remise",
  分红金额: "Montant du dividende",
  返水支出: "Remboursement",
  总返水: "Remise totale",
  流水总额: "Changement total",
  返水总额: "Remboursement total",
  返水详情: "Détails du rabais",
  日流水: "Eau quotidienne",
  "平台根据你下级每日流水进行额外返水奖励,奖励每日新加坡时间00：00进行派发至赏金账户":
    "La plate-forme offre des récompenses de remise supplémentaires en fonction du chiffre d'affaires quotidien de votre subordonné, et les récompenses seront distribuées sur le compte de récompense à 00h00, heure de Singapour, tous les jours.",
  "申请成功，等待审核": "L'application est réussie, en attente d'examen",
  "我出本金，盈利共分享": "Je paye le principal et partage les bénéfices",
  最高分红: "dividende le plus élevé",
  投资大师比赛: "Concours Master Investissement",
  "我出本金，你盈利": "Je paye le principal, tu profites",
  共分享: "partagé",
  最高分红可得: "Dividendes maximums disponibles",
  "新用户专属福利来袭，免费赠送$*，领取后即可投资平台任何项目，盈利后立即可提取。":
    "Des avantages exclusifs pour les nouveaux utilisateurs arrivent, des ${0} gratuits, vous pouvez investir dans n'importe quel projet sur la plateforme après l'avoir reçu, et vous pouvez le retirer immédiatement après avoir réalisé un profit.",
  报名领取: "Inscrivez-vous pour recevoir",
  已领取: "a reçu",
  审核驳回: "Avis rejeté",
  驳回原因: "Raison du rejet",
  活动运行周期: "Cycle d'exécution de l'activité",
  "申请成功后起至*天内完成超额收益。":
    "Une fois la demande acceptée, le revenu excédentaire sera complété dans les {0} jours.",
  分红比: "Ratio de dividende",
  "*日获得盈利后，可获得*%的收益额。":
    "Après avoir réalisé un bénéfice le jour {0}, vous pouvez obtenir {1}% du bénéfice.",
  参与条件: "Conditions de participation",
  "俄罗斯、土耳其地区的用户，且未参与。":
    "Les utilisateurs en Russie et en Turquie n'ont pas participé.",
  计算项目: "élément de calcul",
  "合约、体育、期权": "Contrats, Sports, Options",
  我的投资: "mon investissement",
  参与天数: "Journées de participation",
  累计下注: "mise cumulée",
  累计盈亏: "Gains et pertes cumulés",
  预计可分红: "Devrait verser des dividendes",
  常见问题: "Problème commun",
  什么是平台出资: "Qu'est- ce que le financement de la plateforme",
  "平台根据部分国家的用户，免费提供资金让用户去投项目。":
    "Selon les utilisateurs de certains pays, la plateforme fournit des fonds gratuits aux utilisateurs pour investir dans des projets.",
  怎么获取平台出资的福利:
    "Comment obtenir les avantages de la contribution de la plateforme",
  "您是指定国家的用户即可，点击上方报名按钮，当平台审核完成后将会把*USDT转入当前账户下的赏金账户，您可划转至其他账户下进行投资。":
    "Il vous suffit d'être un utilisateur dans un pays désigné, cliquez sur le bouton d'inscription ci-dessus, et {0} USDT sera transféré sur le compte de prime sous le compte actuel une fois l'examen de la plateforme terminé, et vous pouvez le transférer sur d'autres comptes pour investissement.",
  什么是分红: "qu'est - ce que le dividende",
  "分红指在规定时间内，收益额到达100%后，可分得超额收益的50%。例如：领取100USDT资金，收益额度是120%。":
    "Dividende signifie que dans une période de temps spécifiée, après que le revenu atteint 100%, 50% du revenu excédentaire peut être distribué. Par exemple : pour recevoir des fonds de 100 USDT, le montant du revenu est de 120 %.",
  "如何取得分红？": "Comment obtenir des dividendes ?",
  "活动周期每*天1次，活动结束后进行核算，满足活动要求后分红派发至赏金账户。若你未达到活动要求，系统将自动清除你的收益额和平台的出资。":
    "La période d'activité est une fois tous les {0} jours. Une fois l'activité terminée, elle sera calculée. Une fois les conditions d'activité remplies, les dividendes seront distribués sur le compte de prime. Si vous ne remplissez pas les conditions d'activité, le système effacera automatiquement vos revenus et vos contributions à la plateforme.",
  活动规则: "Règles d'activité",
  "参与的账号需进行KYC认证，每个账户仅限一份福利。":
    "Les comptes participants doivent subir une vérification KYC et chaque compte est limité à un avantage.",
  "参与账号的KYC需要指定的国家方可参与，其他地区无权限参与，请核对活动国家与您的国家是否一致。":
    "Le KYC des comptes participants nécessite que le pays spécifié participe, et les autres régions ne sont pas autorisées à participer. Veuillez vérifier si le pays actif est cohérent avec votre pays.",
  "参与活动成功后，账户将临时锁定您的提现功能，当完成活动后即可解除您的提现功能。":
    "Après avoir participé avec succès à l'activité, le compte verrouillera temporairement votre fonction de retrait et votre fonction de retrait sera libérée une fois l'activité terminée.",
  "请遵守平台活动规则，若发现作弊、利用系统漏洞进行获利，平台将会长期冻结您的账户下所有资金。":
    "Veuillez respecter les règles d'activité de la plate - forme.Si vous trouvez que vous trichez ou exploitez les failles du système à des fins lucratives, la plate - forme gèlera tous les fonds de votre compte pendant une longue période.",
  平台出资: "Investissement dans la plateforme",
  平台出资收回: "Récupération de l'investissement de la plateforme",
  投资大师奖励: "Prix ​​du Master en Investissement",
  请下载APP添加收款方式:
    "Veuillez télécharger l'APP pour ajouter un mode de paiement",
  请下载APP进行身份验证:
    "Veuillez télécharger l'APP pour la vérification d'identité",
  请下载APP参与: "Veuillez télécharger l'APP pour participer",
  技术指标: "Indicateurs techniques",
  主图: "Image principale",
  副图: "Sous-image",
  新注册人数: "Nouveaux inscrits",
  老用户存款人数: "Anciens dépôts d'utilisateurs",
  存款人数: "Nombre de déposants",
  取款人数: "Nombre de retraits",
  投注人数: "Nombre de parieurs",
  "除印度尼西亚、印度、孟加拉国，且未参与过的用户。":
    "À l'exception de l'Indonésie, de l'Inde, du Bangladesh et des utilisateurs qui n'ont pas participé.",
  市场动态: "Dynamique du marché",
  外汇合约: "contrat de change",
  盈亏比: "ratio profits-pertes",
  委托价: "Prix ​​de la commande",
  可用余额: "Solde disponible",
  持仓额: "Montant du poste",
  强平价: "Forte parité",
  修改: "Réviser",
  修改价位: "Modifier le prix",
  外汇: "Forex",
  外汇账户: "Compte Forex",
  我的交易: "ma transaction",
  未设置: "pas encore défini",
  超出最大可设数值: "Dépasse la valeur maximale réglable",
  超出最小可设数值: "Dépasse la valeur minimale réglable",
  止盈超出最小可设数值: "Le take profit dépasse la valeur minimale réglable",
  止损超出最大可设数值: "Le stop loss dépasse la valeur maximale réglable",
  止盈超出最大可设数值: "Le take profit dépasse la valeur maximale réglable",
  止损超出最小可设数值: "Le stop loss dépasse la valeur minimale réglable",
  挖矿: "Exploitation minière",
  交易账户: "compte de transaction",
  买涨: "Acheter",
  买跌: "Acheter ou vendre",
  请输入正确的银行卡信息:
    "Veuillez saisir les informations correctes de votre carte bancaire",
  联系在线客服: "Contacter le service client en ligne",
  法币交易请联系在线客服:
    "Pour les transactions en monnaie légale, veuillez contacter le service client en ligne",
  提交订单: "Soumettre la commande",
  "支付过程如有疑问,请联系在线客服":
    "Si vous avez des questions sur le processus de paiement, veuillez contacter le service client en ligne",
  彩金赠送: "Cadeau couleur or",
  在线客服: "un service en ligne",
  最少投资: "investissement minimum",
  "提交时间:": "Heure de soumission :",
  提现拒绝: "Retrait rejeté",
  认证拒绝: "Authentification rejetée",
  认证通过: "Certification réussie",
  请输入正确的交易额度: "Veuillez saisir le montant correct de la transaction",
  最大下注金额: "Montant maximum de la mise",
  手机号: "Numéro de téléphone",
  邮箱注册: "inscription par courrier électronique",
  手机号注册: "Enregistrement du numéro de téléphone portable",
  查询: "Renseigner",
  手机号登录: "Connexion au numéro de téléphone portable",
  邮箱登录: "Connexion par e-mail",
  请输入数量: "Veuillez entrer la quantité",
  可用数量: "Quantité disponible",
  钱包登录: "Connexion au portefeuille",
  请输入正确的邀请码: "Veuillez saisir le bon code d'invitation",
  "请输入邀请码(必填)": "Veuillez saisir le code d'invitation (obligatoire)",
  输入正确的金额: "Entrez le montant correct",
  法币充值: "recharger avec la monnaie nationale",
  卢比充值: "Recharger en Roupies",
  请输入法币: "Veuillez entrer la devise",
  请输入IFSC: "Veuillez entrer l'IFSC",
  "银行编码(选填)": "Code bancaire (optionnel)",
  请输入银行编码: "Veuillez entrer le code bancaire",
  请输入大于8位数的密码:
    "Veuillez saisir un mot de passe supérieur à 8 chiffres",
  添加成功: "Ajouté avec succès",
  "60秒": "60 seconde",
  "180秒": "180 seconde",
  "300秒": "300 seconde",
  "2次密码不一致": "2 mots de passe sont incohérents",
  输入提币数量: "Entrez le montant du retrait",
  图片格式不正确: "Le format de l'image n'est pas correct",
  图片大于20M: "L'image est supérieure à 20M",
  请设置委托价格: "Veuillez définir un prix de commission",
  输入资金密码: "Entrez le mot de passe de financement",
  验证码错误: "Erreur de code de vérification",
  充值拒绝: "Recharge refusée",
  请输入SSN: "Veuillez saisir le SSN",
  合约交易: "négociation de contrats",
  结算完成: "Règlement terminé",
  继续下单: "Continuer à commander",
  最低购买: "achat minimum",
  最高购买: "achat le plus élevé",
  限价: "Prix Limite",
  买入价格: "Prix d’Achat",
  买入量: "Quantité d’Achat",
  卖出价格: "Prix de Vente",
  卖出量: "Quantité de Vente",
  买入: "Acheter",
  卖出: "Vendre",
  订单创建成功: "Commande Créée avec Succès",
  币币买入支出: "Dépense d’Achat de Crypto",
  币币买入支出退还: "Remboursement de Dépense d’Achat de Crypto",
  币币买入获得: "Crypto Reçue lors de l’Achat",
  币币卖出支出: "Dépense de Vente de Crypto",
  币币卖出支出退还: "Remboursement de Dépense de Vente de Crypto",
  币币卖出获得: "Crypto Reçue lors de la Vente",
  币币交易手续费: "Frais de Transaction Crypto",
  请输入限价: "Veuillez Entrer le Prix Limite",
  成交: "Terminé",
  等待成交: "En Attente de Finalisation",
  交易完成: "Transaction Terminée",
  被取消: "Annulé",
  交易时间: "Heure de la Transaction",
  法币交易: "Échange de monnaie fiduciaire",
  法币出售: "Vente de monnaie fiduciaire",
  两次密码不一致: "Les deux mots de passe ne correspondent pas",
  再次输入账户密码: "Saisissez à nouveau le mot de passe du compte",

  美国: "USA",
  韩国: "Corée du Sud",
  阿尔巴尼亚: "Albanie",
  津巴布韦: "Zimbabwe",
  赞比亚: "Zambie",
  也门: "Yémen",
  美属维尔京群岛: "Îles Vierges américaines",
  英属处女群岛: "Îles Vierges britanniques",
  越南: "Vietnam",
  委内瑞拉: "Venezuela",
  瓦努阿图: "Vanuatu",
  乌兹别克斯坦: "Ouzbékistan",
  乌拉圭: "Uruguay",
  英国: "ROYAUME-UNI.",
  阿拉伯联合酋长国: "Émirats arabes unis",
  乌克兰: "Ukraine",
  乌干达: "Ouganda",
  特克斯和凯科斯群岛: "Îles Turcs et Caicos",
  土库曼斯坦: "Turkménistan",
  土耳其: "Türkiye",
  突尼斯: "Tunisie",
  特立尼达和多巴哥: "Trinidad et Tobago",
  汤加: "Tonga",
  多哥: "Aller",
  东帝汶: "Timor-Leste",
  泰国: "Thaïlande",
  坦桑尼亚: "Tanzanie",
  塔吉克斯坦: "Tadjikistan",
  中国台湾: "Taïwan, Chine",
  叙利亚: "Syrie",
  瑞士: "Suisse",
  瑞典: "Suède",
  斯威士兰: "Swaziland",
  苏里南: "Surinam",
  苏丹: "Soudan",
  斯里兰卡: "Sri Lanka",
  西班牙: "Espagne",
  南非: "Afrique du Sud",
  索马里: "Somalie",
  所罗门群岛: "îles Salomon",
  斯洛文尼亚: "Slovènie",
  斯洛伐克: "Slovaquie",
  "圣马丁岛（荷兰部分）": "Saint Martin (Pays-Bas)",
  新加坡: "Singapour",
  塞拉利昂: "Sierra Leone",
  塞舌尔: "Seychelles",
  塞尔维亚: "Serbie",
  塞内加尔: "Sénégal",
  沙特阿拉伯: "Arabie Saoudite",
  圣多美和普林西比: "Sao tome et principe",
  圣马力诺: "San Marino",
  萨摩亚: "Samoa",
  圣克里斯托弗和尼维斯: "Saint-Christopher et Nevis",
  圣文森特和格林纳丁斯: "Saint Vincent et les grenadines",
  圣彼埃尔和密克隆岛: "Île St. Pierre et Miquelon",
  圣露西亚: "Saint Lucie",
  圣基茨和尼维斯: "St. Kitts et Nevis",
  卢旺达: "Rwanda",
  俄罗斯: "Russie",
  罗马尼亚: "Roumanie",
  留尼汪: "Réunion",
  刚果共和国: "République du Congo",
  卡塔尔: "Qatar",
  波多黎各: "Porto Rico",
  葡萄牙: "Portugal",
  波兰: "Pologne",
  菲律宾: "les Philippines",
  秘鲁: "Pérou",
  巴拉圭: "Paraguay",
  巴布亚新几内亚: "Papouasie-Nouvelle-Guinée",
  巴拿马: "Panama",
  巴勒斯坦: "Palestine",
  帕劳: "Palaos",
  巴基斯坦: "Pakistan",
  阿曼: "Oman",
  挪威: "Norvège",
  尼日利亚: "Nigeria",
  尼日尔: "Niger",
  尼加拉瓜: "Nicaragua",
  新西兰: "Nouvelle-Zélande",
  新喀里多尼亚: "Nouvelle-Calédonie",
  荷属安德列斯群岛: "Pays-Bas Andrés îles",
  荷兰: "Pays-Bas",
  尼泊尔: "Népal",
  纳米比亚: "Namibie",
  缅甸: "Myanmar",
  莫桑比克: "Mozambique",
  摩洛哥: "Maroc",
  蒙特塞拉特岛: "Montserrat Island",
  黑山: "Monténégro",
  蒙古: "Mongolie",
  摩纳哥: "Monaco",
  摩尔多瓦: "Moldavie",
  墨西哥: "Mexique",
  马约特: "Mayot",
  毛里求斯: "Maurice",
  毛里塔尼亚: "Mauritanie",
  马里亚纳群岛: "Îles Mariana",
  马提尼克: "Martinique",
  马耳他: "Malte",
  马里: "Mali",
  马尔代夫: "Maldives",
  马来西亚: "Malaisie",
  马拉维: "Malawi",
  马达加斯加: "Madagascar",
  马其顿: "Macédoine",
  中国澳门: "Macao, Chine",
  卢森堡: "Luxembourg",
  立陶宛: "Lituanie",
  列支敦士登: "Liechtenstein",
  利比亚: "Libye",
  利比里亚: "Libéria",
  莱索托: "Lesotho",
  黎巴嫩: "Liban",
  拉脱维亚: "Lettonie",
  老挝: "Laos",
  吉尔吉斯斯坦: "Kirghizistan",
  科威特: "Koweit",
  基里巴斯: "Kiribati",
  肯尼亚: "Kenya",
  哈萨克斯坦: "Kazakhstan",
  约旦: "Jordanie",
  日本: "Japon",
  牙买加: "Jamaïque",
  象牙海岸: "Côte d'Ivoire",
  意大利: "翻译失败: The read operation timed out",
  以色列: "Israël",
  爱尔兰: "Irlande",
  伊拉克: "Irak",
  伊朗: "L'Iran",
  印度尼西亚: "Indonésie",
  印度: "Inde",
  冰岛: "Islande",
  匈牙利: "Hongrie",
  中国香港: "Hong Kong, Chine",
  洪都拉斯: "Honduras",
  海地: "Haïti",
  圭亚那: "Guyane",
  几内亚比绍共和国: "République de Guinée-Bissau",
  几内亚: "Guinée",
  危地马拉: "Guatemala",
  关岛: "Guam",
  瓜德罗普岛: "Guadeloupe",
  格林纳达: "Grenceda",
  格陵兰岛: "Groenland",
  希腊: "Grèce",
  直布罗陀: "Gibraltar",
  加纳: "Ghana",
  德国: "Allemagne",
  格鲁吉亚: "Géorgie",
  冈比亚: "Gambie",
  加蓬: "Gabon",
  法属波利尼西亚: "Polynésie française",
  法属圭亚那: "Guyane française",
  法国: "France",
  芬兰: "Finlande",
  斐济: "Fidji",
  法罗群岛: "Îles Féroé",
  埃塞俄比亚: "Ethiopie",
  爱沙尼亚: "Estonie",
  厄立特里亚: "Érythrée",
  赤道几内亚: "Guinée équatoriale",
  萨尔瓦多: "El Salvador",
  埃及: "Egypte",
  厄瓜多尔: "Equateur",
  多米尼加共和国: "République dominicaine",
  多米尼加: "dominicain",
  吉布提: "Djibouti",
  丹麦: "Danemark",
  捷克: "République tchèque",
  塞浦路斯: "Chypre",
  库拉索: "Curacao",
  古巴: "Cuba",
  克罗地亚: "Croatie",
  哥斯达黎加: "Costa Rica",
  科特迪瓦: "Côte d'Ivoire",
  库克群岛: "Îles cuisinées",
  科摩罗: "Comores",
  哥伦比亚: "Colombie",
  智利: "Chili",
  乍得: "Tchad",
  中非共和国: "République centrafricaine",
  佛得角: "Cape Verde",
  开曼群岛: "Îles Caïmans",
  开普: "Kaipu",
  加拿大: "Canada",
  喀麦隆: "Cameroun",
  柬埔寨: "Cambodge",
  布隆迪: "Burundi",
  布基纳法索: "Burkina Faso",
  保加利亚: "Bulgarie",
  文莱: "Brunei",
  巴西: "Brésil",
  博茨瓦纳: "Botwana",
  波斯尼亚和黑塞哥维那: "Bosnie et Herzégovine",
  玻利维亚: "Bolivie",
  不丹: "Bhoutan",
  百慕大群岛: "Îles des Bermudes",
  贝宁: "Bénin",
  伯利兹: "Belize",
  比利时: "Belgique",
  白俄罗斯: "Biélorussie",
  巴巴多斯: "Barbade",
  孟加拉国: "Bangladesh",
  巴林: "Bahreïn",
  巴哈马: "Bahamas",
  阿塞拜疆: "Azerbaïdjan",
  奥地利: "Autriche",
  澳大利亚: "Australie",
  阿鲁巴: "Aruba",
  亚美尼亚: "Arménie",
  阿根廷: "Argentine",
  安提瓜和巴布达: "Antigua et Barbuda",
  安圭拉: "Anguille",
  安哥拉: "Angola",
  安道尔: "Andorre",
  美属萨摩亚: "Samoa américaine",
  阿尔及利亚: "Algérie",
  中国: "Chine",

  日收益: "Bénéfice quotidien",
  "30天预期收益": "Bénéfice prévu sur 30 jours",
  英伟达高速矿机: "Machine de minage haute vitesse NVIDIA",
  去投资: "Aller investir",
  新币榜: "Classement des nouvelles monnaies",
  主题: "Thème",
  立即探索: "Explorer immédiatement",
  等您来: "Nous vous attendons",
  最新活动: "Dernières activités",
  货币划转: "Transfert de devises",
  提现钱包: "Portefeuille de retrait",
  加密合约: "Contrat cryptographique",
  外汇期货: "Futures de change",
  定期: "À terme fixe",
  探索产品: "Explorer les produits",
  稳健型: "Type conservateur",
  高收益: "Haut rendement",
  期货账户: "Compte de futures",
  时间线: "Chronologie",
  收藏: "Favoris",
  委托订单: "Commande de consignation",
  最新交易: "Dernières transactions",
  深度图: "Graphique de profondeur",
  标记价格: "Prix marqué",
  "24h最高价": "Prix maximum sur 24h",
  "24h成交量": "Volume de transaction sur 24h",
  "24h最低价": "Prix minimum sur 24h",
  "24h成交额": "Montant de transaction sur 24h",
  "价格(USDT)": "Prix (USDT)",
  "数量(ETH)": "Quantité (ETH)",
  看空: "Position courte",
  余额不足: "Solde insuffisant",
  最低购买: "Achat minimum",
  最高购买: "Achat maximum",
  下单成功: "Commande passée avec succès",
  平仓成功: "Clôture de position réussie",
  请输入正确的平仓数量:
    "Veuillez entrer le bon nombre pour la clôture de position",
  加仓成功: "Augmentation de position réussie",
  请输入正确的加仓金额:
    "Veuillez entrer le bon montant pour l'augmentation de position",
  收藏成功: "Ajouté aux favoris avec succès",
  取消收藏成功: "Supprimé des favoris avec succès",
  日收益率: "Taux de rendement quotidien",
  轻松理财: "Gestion de patrimoine facile",
  立即申购: "Souscrire immédiatement",
  申购日期: "Date de souscription",
  加密货币: "Monnaie cryptographique",
  交割合约: "Contrat à livrer",
  最小投资: "Investissement minimum",
  委托: "Consignation",
  "当指数价格触达时，将会触发委托平仓":
    "Lorsque le prix de l'indice est atteint, la clôture de position consignée sera déclenchée",
  预计盈利: "Bénéfice prévu",
  最大投资: "Investissement maximum",
  现货交易: "Trading crypto",
  输入交易金额: "Entrez le montant de la transaction",
  "可用额度：": "Limite disponible :",
  提现货币: "Devise de retrait",
  期货合约: "Contrat de futures",
  加密币永续: "Perpétuel crypto",
  外汇永续: "Perpétuel Forex",
  期权账户: "Compte d’options",
  夜间模式: "Mode nuit",
  未结盈亏: "Non rentable",
  超额收益: "Gains excédentaires",
  "安全策略，低买高卖": "Politique de sécurité, acheter bas et vendre haut",
  投资金额应为: "Le montant de l'investissement doit être",
  总收益率: "Rendement total",
  赎回成功: "Rédemption réussie",
  快捷卖币: "Vente rapide",
  修改止盈止损: "Modifier TP/SL",
  白皮书: "Livre blanc",

  托管资金: "Fonds en gestion",
  托管中: "En gestion",
  预计日收益: "Revenu quotidien estimé",
  累计收益: "Revenus totaux",
  周期: "Période",
  日收益: "Revenu quotidien",
  限额: "Limite",
  立即托管: "Investir maintenant",
  "已鎖定 請聯繫客服": "Verrouillé, veuillez contacter le service client",
  产品列表: "Liste des produits",
  规则: "Règles",
  创建订单: "Créer une commande",
  产品名称: "Nom du produit",
  托管周期: "Période de gestion",
  等级限制: "Restriction de niveau",
  托管金额: "Montant de gestion",
  限额: "Limite",
  余额: "Solde",
  购买日: "Date d'achat",
  起息日: "Date de début des intérêts",
  派息时间: "Heure de distribution des revenus",
  每天: "Chaque jour",
  计息结束日: "Date de fin des intérêts",
  每日收益: "Revenu quotidien",
  预计收益: "Revenu estimé",
  "收益将自动发送至您的余额账户;":
    "Les revenus seront automatiquement envoyés sur votre compte de solde;",
  "您的资金没有任何风险;": "Vos fonds ne présentent aucun risque;",
  "365*24小时不断地工作;": "Fonctionne 24h/24, 365 jours par an;",
  托管中: "En gestion",
  结束: "Terminé",
  今日收益: "Revenu du jour",
  剩余周期: "Période restante",
  进行中: "En cours",
  已发放: "Versé",
  信誉分: "Points de réputation",

  复制成功: "Copié avec succès",
  VIP权益: "Avantages VIP",
  旧密码: "Ancien mot de passe",
  请输入旧密码: "Veuillez saisir l'ancien mot de passe",
  "忘记旧密码请联系客服重置。":
    "Si vous avez oublié votre ancien mot de passe, veuillez contacter le service client pour le réinitialiser.",
  去升级: "Passer à la version supérieure",
  描述: "Description",
  实际存款金额: "Montant réel du dépôt",
  升级礼金: "Prime de mise à niveau",
  隔夜利息: "Intérêts overnight (swap)",
  自动结算: "Règlement automatique",
  等级规则: "Règles de niveau",
  "WEB3.0币持有数据收益": "Rendement des données de détention de jetons WEB3.0",
  总生产: "Production totale",
  有效节点: "Nœuds actifs",
  参与人: "Participants",
  用户收益: "Rendement utilisateur",
  "流动性WEB3.0输出": "Sortie de liquidité WEB3.0",
  总资产: "Actif total",

  ETHAI持有数据收益: "Rendement des données de détention d'ETHAI",
  AI量化流动性: "Liquidité quantitative par IA",
  现货买入手续费: "Frais d'achat au comptant",
  现货支出: "Dépense au comptant",
  现货资金费率: "Taux de financement au comptant",
  现货卖出手续费: "Frais de vente au comptant",
  现货收入: "Revenu au comptant",
  外汇合约支出: "Dépense de contrat de change",
  外汇合约买入手续费: "Frais d'achat de contrat de change",
  外汇合约资金费率: "Taux de financement de contrat de change",
  外汇合约卖出手续费: "Frais de vente de contrat de change",
  外汇合约收入: "Revenu de contrat de change",
  理财购买: "Achat de produit financier",
  VIP理财日收益: "Rendement quotidien du produit financier VIP",
  VIP理财隔夜利息: "Intérêt overnight du produit financier VIP",
  VIP本金返还: "Remboursement du capital VIP",
  VIP彩金发放: "Distribution de bonus VIP",
  VIP彩金抵扣: "Déduction de bonus VIP",
  隔夜利息: "Intérêt overnight",
  设置资产密码: "Définir le mot de passe des actifs",

  锁仓挖矿: "Minage avec verrouillage",
  一站式理财服务: "Service financier tout-en-un",
  产品: "Produits",
  客服中心: "Centre de service client",
  贷款: "Prêts",
  挖矿赚不停: "Gains de minage continus",
  "锁仓挖矿是通过将USDT (USD:1USDT=1USD) 托管给平台超算力矿机，在平台矿池中进行挖矿收益。":
    "Le minage avec verrouillage consiste à confier des USDT (USD:1USDT=1USD) aux machines de minage haute puissance de la plateforme afin de générer des revenus dans le pool de minage de la plateforme.",
  产品优势: "Avantages du produit",
  随存随取: "Dépôt et retrait flexibles",
  锁仓周期: "Période de verrouillage",
  每日下发: "Distribution quotidienne",
  随机空投: "Airdrop aléatoire",
  "100%资金安全保障": "100% de sécurité des fonds garantie",
  "100%节假日收益不间断": "Revenus continus à 100% même les jours fériés",
  成功锁仓后当天产出: "Gains générés le jour même après verrouillage réussi",
  关于违约金: "À propos des pénalités",
  "若您希望转出未到期的本金,则会产生违约金,违约金=违约结算比例*剩余天数*锁仓金额.":
    "Si vous souhaitez retirer le capital avant l’échéance, des pénalités seront appliquées. Pénalité = taux de pénalité × jours restants × montant verrouillé.",
  "举例:此锁仓挖矿的违约结算比例为5%,剩余3天到期,锁仓金额为10000U《USDT/USD》,则违约金=5%*3*10000=1500U,实际退回本金为15000U-1500U":
    "Exemple : le taux de pénalité de ce produit de minage verrouillé est de 5 %, il reste 3 jours avant l’échéance et le montant verrouillé est de 10000U (USDT/USD). La pénalité = 5%×3×10000=1500U, le capital réellement remboursé est 15000U-1500U.",
  收益计算: "Calcul des gains",
  "平台有多种锁仓挖矿理财产品供使用者选择,收益计算如下,举例:":
    "La plateforme propose plusieurs produits financiers de minage avec verrouillage. Le calcul des gains est le suivant, par exemple :",
  "会员在平台锁仓10000U(USDT,USD),如选择了周期为7天,日产出为锁仓金额的0.7%~1.8%的理财产品,则每天产出如下":
    "Si un utilisateur verrouille 10000U (USDT, USD) sur la plateforme et choisit un produit de 7 jours avec un rendement quotidien de 0,7% à 1,8% du montant verrouillé, le gain quotidien est le suivant :",
  "最低:10000Ux0.7%=70U;": "Minimum : 10000U × 0,7% = 70U;",
  "最高:10000Ux1.8%=180U;": "Maximum : 10000U × 1,8% = 180U;",
  "即7天后可获得490U~1260U的收益,收益每日下发,锁仓本金到期后,自动转入您的资金账户.":
    "Après 7 jours, vous pouvez obtenir entre 490U et 1260U de gains. Les revenus sont distribués quotidiennement et le capital verrouillé est automatiquement transféré sur votre compte à l’échéance.",
  正在托管的资金: "Fonds sous gestion",
  签到: "Connexion quotidienne",
  锁仓订单: "Ordres de verrouillage",
  预计今日收益: "Revenus estimés du jour",
  累计收益: "Revenus cumulés",
  托管中的订单: "Ordres en gestion",
  单笔最少: "Montant minimum par ordre",
  单笔最多: "Montant maximum par ordre",
  日收益率: "Rendement quotidien",
  说明: "Description",
  "1.数据统计时间以GMT+8时间为准<br>2.每日收益值以GMT+8当天时间00:00-23:59点(本地时间00:00-23:59)的所有已结算订单为基准计算得出<br>3.当天的收益会统一在次日GMT+8时间00:00-00:10内派发.":
    "1. Les statistiques sont basées sur GMT+8<br>2. Les gains quotidiens sont calculés à partir de toutes les ordres réglés entre 00:00 et 23:59 GMT+8 (heure locale 00:00-23:59)<br>3. Les gains du jour sont distribués le lendemain entre 00:00 et 00:10 GMT+8.",
  知道了: "Compris",
  锁仓: "Verrouiller",
  派息时间: "Heure de distribution",
  每日: "Quotidien",
  托管资金: "Fonds en gestion",
  到期返回: "Retour à échéance",
  提前赎回: "Rachat anticipé",
  预计收益: "Gain estimé",
  认购: "Souscription",
  热门: "Populaire",
  数字货币: "Cryptomonnaies",
  贵金属: "Métaux précieux",
  大宗商品: "Matières premières",
  持仓明细: "Détails des positions",
  历史明细: "Historique",
  当前价: "Prix actuel",
  "↑买涨": "↑ Acheter à la hausse",
  "↓买跌": "↓ Acheter à la baisse",
  显示全部: "Afficher tout",
  买入金额: "Montant d’achat",
  方向: "Direction",
  收益: "Gain",
  预期收益: "Gain attendu",
  估用保证金: "Marge estimée",
  确认下单: "Confirmer la commande",
  锁定: "Verrouillé",
  账户总资产: "Actifs totaux du compte",
  明细: "Détails",
  今日收益: "Revenus du jour",
  仓位保证金: "Marge de position",
  持有仓位: "Positions détenues",
  "锁定金额=所有锁仓挖矿中未完成订单的金额总和":
    "Montant verrouillé = somme de toutes les commandes de minage verrouillé non terminées",
  "1.数据统计时间以GMT+8时间为准<br>2.每日收益值以GMT+8当天时间00:00-23:59点(本地时间00:00-23:59)的所有已结算订单为基准计算得出":
    "1. Les statistiques sont basées sur GMT+8<br>2. Les gains quotidiens sont calculés à partir de toutes les ordres réglés entre 00:00 et 23:59 GMT+8 (heure locale 00:00-23:59)",
  充值方式: "Méthode de dépôt",
  银行汇款: "Virement bancaire",
  "银行汇款请联系客服进行操作!":
    "Veuillez contacter le service client pour effectuer un virement bancaire !",
  提款方式: "Méthode de retrait",
  "银行提款请联系客服进行操作!":
    "Veuillez contacter le service client pour effectuer un retrait bancaire !",
  资金明细: "Détails des fonds",
  提现记录: "Historique des retraits",
  拒绝: "Refusé",
  通过: "Approuvé",
  拒绝原因: "Motif du refus",

  消息公告: "Annonces",
  订单: "Commandes",
  个人中心: "Centre personnel",
  "未到期赎回需支付一定的违约金!":
    "Le rachat anticipé entraîne le paiement d’une pénalité.",

  请输入区号: "Veuillez saisir l’indicatif régional",
  "请选择国家/地区": "Veuillez sélectionner un pays/une région",

  今日开盘: "Ouverture du jour",
  昨日收盘: "Clôture d'hier",
  实名认证即送: "Recevez immédiatement après la vérification d'identité",
  立即认证: "Vérifier maintenant",
  新用户礼包: "Pack cadeau pour les nouveaux utilisateurs",
  完成新人任务领取:
    "Terminez les tâches des nouveaux utilisateurs pour le récupérer",
  认证: "Vérifier",
  时间周期: "Période",
  支付金额: "Montant du paiement",
  已平仓: "Fermé",
  "MGBX 新用户欢迎礼包：每位用户最多可获得":
    "Pack de bienvenue MGBX pour les nouveaux utilisateurs : chaque utilisateur peut recevoir au maximum",
  我已经阅读并同意: "J'ai lu et j'accepte",
  隐私政策: "Politique de confidentialité",

  放弃奖励离开: "Abandonner la récompense et quitter",
  继续注册: "Continuer l'inscription",
  分钟: "Minutes",

  "请先勾选隐私政策!":
    "Veuillez d'abord consulter la politique de confidentialité !",

  添加其他到自选: "Ajouter d'autres éléments à la liste de suivi",

  充值最高可得: "Effectuez un rechargement et obtenez jusqu'à 30 000 $.",

  请输入格式正确的手机号:
    "Veuillez saisir un numéro de téléphone portable valide.",

  收起: "Collapse",
  上传截图: "Upload screenshot",
  "*充值成功后必须上传充值截图，否则将视为无效存款。": "*After a successful recharge, you must upload the recharge screenshot; otherwise the deposit will be invalid.",
};
// 法语



// WEBPACK FOOTER //
// ./src/lang/fr.js